import { Injectable, signal } from "@angular/core";
import { INotification } from "@common/defs/notify.defs";
import { environment } from "environments/environment.development";

@Injectable({
    providedIn: 'root'
})
export class NotifyService {
    private readonly _notifications = signal<INotification[]>([]);

    postNotification(notification: INotification) {
        this._notifications.set([notification]);
    }

    get notifications() {
        return this._notifications;
    }

    showToast(toast: Partial<INotification>) {
        const notification: INotification = {
            summary: toast.summary || environment.appTitle,
            detail: toast.detail || 'Operação realizada com sucesso',
            severity: toast.severity || 'success',
            type: toast.type || 'toast',
            life: toast.life || 5000
        }

        this.postNotification(notification);
    }

    showMessage(message: Partial<INotification>) {
        const notification: INotification = {
            summary: message.summary || environment.appTitle,
            detail: message.detail || 'Operação realizada com sucesso',
            severity: message.severity || 'success',
            type: message.type || 'message',
            life: message.life || 500
        };

        this.postNotification(notification);
    }
}